import cx from 'classnames'

import { getColumnWidth } from './columnStyles'

export const Col = ({ children, className, lg, md, noGutter = false, xs, ...props }) => (
  <div
    className={cx(
      'tw:w-full tw:flex-none',
      !noGutter && 'tw:px-3',
      getColumnWidth('xs', xs),
      getColumnWidth('md', md),
      getColumnWidth('lg', lg),
      className,
    )}
    {...props}
  >
    {children}
  </div>
)
